import PropTypes from 'prop-types';
/* eslint-disable import/prefer-default-export */

export var childrenPropType = PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]);